import React from 'react';
import { motion } from 'framer-motion';

// Create a motion button component
const MotionButton = motion.button;

const Button = ({ 
  children, 
  variant = 'primary', 
  className = '', 
  animated = true,
  ...props 
}) => {
  const baseStyles = {
    primary: 'bg-primary-600 text-white hover:bg-primary-700',
    secondary: 'bg-white text-primary-600 border border-primary-300 hover:bg-gray-50',
    ghost: 'text-gray-600 hover:text-gray-900'
  };

  const buttonClass = `px-4 py-2 rounded-lg transition-colors ${baseStyles[variant]} ${className}`;

  // If animated is true, use MotionButton with animation props
  if (animated) {
    return (
      <MotionButton
        className={buttonClass}
        initial={{ opacity: 1 }}
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        transition={{ duration: 0.2 }}
        {...props}
      >
        {children}
      </MotionButton>
    );
  }

  // If not animated, use regular button
  return (
    <button 
      className={buttonClass}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;